import createPdf, {
  baseFontSize,
  createTableHeader,
  createDividerRow,
  createPages,
  createDocument,
} from '../createPdf';

import { find, flatMap, get, pick, range } from 'lodash';

const SPACE = ' ';

const yearOfBirth = (dateOfBirth) => {
  if (dateOfBirth == SPACE)
    return SPACE;

  return dateOfBirth.split('.')[2];
}


const createProtocolRow = ({ row, meta }, index) => {
  const athlete = (key, fallback) => get(row, ['athlete', key], fallback);
  const attempt = (lift, number) => {
    const result = get(row, ['resultsByLiftId', lift.id]);
    const attempt = find(get(row, ['attemptsByLiftId', lift.id]), { number });
    // FIXME: decision check should not be needed?
    if (attempt && attempt.decision) {
      const { weight, decision } = attempt;
      return decision.isGoodLift
        ? { text: weight, decoration: 'underline' }
        : { text: `(${weight})`, decoration: 'lineThrough', fillColor: '#DDD' };
    } else if (result !== undefined) {
      return { text: '---' };
    }

    if (number === 1) {
      const text =
        get(row.athlete, ['weighInDeclarationsByLiftId', lift.id]) || SPACE;
      return { text, fontSize: baseFontSize / 2, italics: true };
    }
    return { text: SPACE };
  };
  const result = lift => {
    const result = get(row, ['resultsByLiftId', lift.id]);
    return { text: result === 0 ? '---' : result, bold: true };
  };
  const total = () => {
    const total = get(row, 'total');
    return { text: total === 0 ? '---' : total, bold: true };
  };
  return [
    { text: index + 1, alignment: 'right' },
    { text: athlete('lotNumber', SPACE), alignment: 'right' },
    { text: athlete('name', SPACE) },
    { text: yearOfBirth(athlete('dateOfBirth', SPACE)) },
    { text: athlete('teams', [SPACE]).join(', ') },
    { text: athlete('ageGroups', [SPACE]).join(', ') },
    //{ text: athlete('categories', [SPACE]).join(', '), alignment: 'right' },
    { text: athlete('entryTotal', SPACE), alignment: 'right' },
    { text: athlete('bodyweight', SPACE), alignment: 'right' },
    ...flatMap(meta.orm.lifts, lift => [
      ...range(1, lift.attemptCount + 1).map(number => attempt(lift, number)),
      result(lift),
    ]),
    total(),
  ];
};

// FIXME: Consolidate with the others.
/*
const createSignatureLines2 = names => ({
  fontSize: 12,
  bold: true,
  layout: {
    defaultBorder: false,
  },
  table: {
    widths: [100, '*', 100, '*', 100],
    body: [
      [
        SPACE,
        { fontSize: 3 * 12, text: SPACE, border: [false, false, false, true] },
        SPACE,
        { fontSize: 3 * 12, text: SPACE, border: [false, false, false, true] },
        SPACE,
      ],
      [SPACE, { text: names[0] }, SPACE, { text: names[1] }, SPACE],
    ],
  },
});
*/

console.error('FIXME: Consolidate');
const createSignatureLines3 = names => ({
  fontSize: 12,
  bold: true,
  layout: {
    defaultBorder: false,
  },
  table: {
    widths: [100, '*', 100, '*', 100, '*', 100],
    body: [
      [
        SPACE,
        { fontSize: 3 * 12, text: SPACE, border: [false, false, false, true] },
        SPACE,
        { fontSize: 3 * 12, text: SPACE, border: [false, false, false, true] },
        SPACE,
        { fontSize: 3 * 12, text: SPACE, border: [false, false, false, true] },
        SPACE,
      ],
      [
        SPACE,
        { text: names[0] },
        SPACE,
        { text: names[1] },
        SPACE,
        { text: names[2] },
        SPACE,
      ],
    ],
  },
});

const createProtocolPage = ({ protocol, meta }) => {
  const headers1 = [
    { text: '', rowSpan: 2 },
    { text: 'LOT', rowSpan: 2 },
    { text: 'NAME', rowSpan: 2 },
    { text: 'DOB', rowSpan: 2 },
    { text: 'TEAM', rowSpan: 2 },
    { text: 'AGE GROUP', rowSpan: 2 },
    //{ text: 'BW\nCAT', rowSpan: 2 },
    { text: 'ENTRY', rowSpan: 2 },
    { text: 'BW', rowSpan: 2 },
    { text: 'SNATCH', colSpan: 4 },
    '',
    '',
    '',
    { text: 'CLEAN and JERK', colSpan: 4 },
    '',
    '',
    '',
    { text: 'TOTAL' },
  ];
  const headers2 = [
    '',
    '',
    '',
    '',
    '',
    '',
    //'',
    '',
    '',
    { text: '1' },
    { text: '2' },
    { text: '3' },
    { text: '=' },
    { text: '1' },
    { text: '2' },
    { text: '3' },
    { text: '=' },
    { text: '=' },
  ];
  const widths = [
    10,
    15,
    '*',
    45,
    45,
    45,
    //25,
    25,
    25,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    20,
    25,
  ];
  let previousCategory;
  const rows = flatMap(protocol.rows, (row, index) => {
    const { category } = row.athlete;
    const divider = category !== previousCategory &&
      !!index && [createDividerRow(headers1.length, category)];
    previousCategory = category;
    const protocolRow = createProtocolRow({ row, meta }, index);
    return [...(divider || []), protocolRow];
  });
  return [
    {
      text: `PROTOCOL ${protocol.title}`,
      style: 'header',
    },
    {
      table: {
        headerRows: 2,
        fontSize: baseFontSize / 1.2,
        widths,
        body: [
          createTableHeader(headers1),
          createTableHeader(headers2),
          ...rows,
        ],
      },
    },
    //createSignatureLines(['Competition Director', 'Jury President']),
    createSignatureLines3(['Referee 1', 'Referee 2', 'Referee 3']),
  ];
};

const createProtocolsPdf = (protocols, meta) => {
  const [event] = meta.orm.events;
  const documentDefinition = createDocument(
    'Protocols',
    createPages(
      protocols,
      protocol => createProtocolPage({ protocol, meta }),
      pick(event, 'title', 'location', 'duration'),
    ),
    { pageOrientation: 'landscape' },
  );

  return createPdf(documentDefinition);
};

export default createProtocolsPdf;



// WEBPACK FOOTER //
// ./src/pages/Home/protocols/createProtocolsPdf.js